import React, { Component } from "react";
import LeafletRuler from "./LeafletRuler";

class LeafletRulerWrapper extends Component {
  render() {
    return <div style={{ position: "absolute",}}>
        <LeafletRuler />
    </div>;
  }
}

export default React.memo(LeafletRulerWrapper);
